"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SvgIcon = (0, _createSvgIcon["default"])([/*#__PURE__*/React.createElement("mask", {
  id: "mask0_151_48831",
  style: {
    "maskType": "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "3",
  width: "16",
  height: "10",
  key: "0"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 10v1.5c0 .8284-.6716 1.5-1.5 1.5H3c-1.6568 0-3-1.3431-3-3V4.5C0 3.6716.6716 3 1.5 3H9c1.6569 0 3 1.3431 3 3l2.8-2.1c.4944-.3708 1.2-.018 1.2.6v7c0 .6181-.7056.9708-1.2.6L12 10ZM1.5 4H9c1.1046 0 2 .8954 2 2v5.5a.5.5 0 0 1-.5.5H3c-1.1046 0-2-.8954-2-2V4.5a.5.5 0 0 1 .5-.5ZM12 8.75 15 11V5l-3 2.25v1.5Z",
  fill: "#000001"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_151_48831)",
  key: "1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#131619",
  d: "M0 0h16v16H0z"
}))], 'IconZoomMeetingIcon', '1em', '1em', '', '0 0 16 16');
SvgIcon.displayName = 'IconZoomMeeting';
var _default = SvgIcon;
exports["default"] = _default;